// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export { default as AWSPinpointProvider } from './AWSPinpointProvider';
//# sourceMappingURL=index.js.map